import { createEvent, restore, sample } from 'effector'
import { ContentSettingFormType } from './types'
import { fx } from '../../../../libs'
import { $params } from '../../../../features/router'
import { createDemoContest } from '../DemoContestForm/model'

export const getTextsSettingMounted = createEvent()

export const submitCreateTextsSetting = createEvent<
  ContentSettingFormType & { contestName: string }
>()

export const submitEditTextsSetting = createEvent<
  ContentSettingFormType | { contestName: string }
>()

export const setTextsSettingForm = createEvent<ContentSettingFormType>()

export const createTextsSetting = fx<
  ContentSettingFormType & { contestName: string },
  void
>({
  method: 'POST',
  url: '/contest_content/bulk',
})

export const editTextsSetting = fx<
  ContentSettingFormType | { contestName: string },
  void
>({
  method: 'POST',
  url: '/contest_content/bulk',
})

export const getTextsSetting = fx<
  void,
  ContentSettingFormType & { contestName: string }
>({
  method: 'GET',
  url: '/contest_content/array',
})

export const $textsSetting = restore(setTextsSettingForm, {
  name: '',
  description: '',
  winnersInfoTitle: '',
  winnersInfoPrizes: '',
  winnersInfoFooter: '',
  infoTradingInstruments: '',
  firstFullName: '',
  firstName: '',
  secondFullName: '',
  secondName: '',
  infoTitle: '',
  infoPrizes: '',
})

export const $textsSettingCreateStatus = restore<{
  isSuccess: boolean
}>(
  createTextsSetting.doneData.map((a) => {
    return {
      isSuccess: true,
    }
  }),
  {
    isSuccess: false,
  },
)

sample({
  clock: submitCreateTextsSetting,
  fn: (contentSettings) => {
    return {
      url: `/contest_content/bulk`,
      body: { ...contentSettings },
    }
  },
  target: createTextsSetting,
})

sample({
  clock: submitEditTextsSetting,
  source: $params,
  fn: (params, contentSettings) => {
    let id
    if (params) {
      id = params.demoContestID
    }

    return {
      url: `/contest_content/bulk`,
      body: { ...contentSettings, contestId: id },
    }
  },
  target: editTextsSetting,
})

sample({
  clock: getTextsSettingMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.demoContestID
    }
    return {
      url: `/contest_content/array?where={"contestId": ${id}}`,
    }
  },
  target: getTextsSetting,
})

sample({
  clock: getTextsSetting.doneData,
  fn: (doneData) => doneData.body,
  target: setTextsSettingForm,
})
